/**
 * The span START attribute that `PrioritySampler` keys on (tdd-0110).
 *
 * Its own dependency-free module so the eager browser error listener can use
 * it without pulling `@opentelemetry/api` into the first-load bundle.
 */
export const SAMPLING_PRIORITY_ATTR = "sampling.priority";
